.contact__form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 800px;
}

.contact__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.contact__input {
  background-color: inherit;
  color: inherit;
  padding: 8px;
}

.contact__message {
  height: 5rem;
}

.contact__submit {
  align-self: center;
}
